module.exports = __webpack_public_path__ + "img/telegram-griss-logo-16x16.d9704a98.svg";